import { useTranslation } from 'react-i18next';
import { BenefitIcon } from '@/common/components/BenefitIcon/BenefitIcon';
import { Card } from '@/common/components/Card/Card';
import { Label } from '@/common/components/Label/Label';
import { Stack } from '@/common/components/Stack/Stack';
import { ROUTES } from '@/common/constants/routes';
import { IMenhirBenefitSlug } from '@/common/integrations/menhir/employee/benefits/benefits.types';
import { MoneyUtils, TMoney } from '@coverflex-tech/hypernova-utils';
import { useRouter } from 'expo-router';

export type TESBenefitsSpendingCardProps = {
  slug: IMenhirBenefitSlug;
  balance: TMoney;
};

export function ESBenefitsSpendingCard({
  slug,
  balance,
}: TESBenefitsSpendingCardProps) {
  const { t } = useTranslation();
  const router = useRouter();
  const noBalance = balance?.amount === 0;
  return (
    <Card
      onPress={() => {
        router.push({
          pathname: ROUTES.BENEFIT_DETAIL,
          params: { slug },
        });
      }}
    >
      <Stack gap="md">
        <Stack horizontal align="center" gap="md">
          <BenefitIcon
            benefit={slug}
            color={noBalance ? 'neutral20' : undefined}
          />
          <Label color={noBalance ? 'neutral20' : undefined}>
            {t(`general.benefits.${slug}`)}
          </Label>
        </Stack>
        <Label size="xl" bold color={noBalance ? 'neutral20' : undefined}>
          {MoneyUtils.moneyToString(balance)}
        </Label>
      </Stack>
    </Card>
  );
}
